<template>
  <div>
    <template v-if="!wapShow">
    <header1 :menuIndex="4"></header1>
    <div class="case-box">
      <div class="case-banner">
        <div class="app-content">
          <span class="homme-sp1" style="">基于数字化的工程检测［专精特新］之道</span>
          <span class="homme-sp2" style="line-height: 2;">把数字化带入预应力工程中的每个构件、每个项目、每个组织，构建“数字建造”时代的工程物联网世界</span>
        </div>
        <img src="@/assets/imgs/case/3.png"/>
      </div>

      <div class="case-content">
        <div class="app-content">
          <div class="t1">典型案例</div>

          <div style="width: 100%;height: 730px;overflow: hidden">
            <vue-seamless :data="projectList" :class-option="defaultOptionLeft">
              <div class="case-content-box">
                <div class="case-li flex-center" v-for="item in projectList" :class="{'select':item.cover}"
                     @click="toPape(item)">
                  <img v-if="item.cover" :src="item.cover"/>
                  <div style="text-align: center;position: relative;z-index: 2">
                    <p class="year" :style="{'color':item.cover?'#ffffff':''}">{{item.year}}</p>
                    <p class="name" :style="{'color':item.cover?'#ffffff':''}">{{item.name}}</p>
                    <div class="line" :style="{'background':item.cover?'#ffffff':''}"></div>
                    <p class="detail select" :style="{'color':item.cover?'#ffffff':''}">{{item.orgName}}</p>
                    <div class="more select" :style="{'color':item.cover?'#ffffff':''}">查看详情</div>
                  </div>
                </div>
              </div>
            </vue-seamless>
          </div>
        </div>
      </div>


      <div class="type-box" :style="{'background-image':'url('+proObjList.cover+')'}">
        <div class="app-content">
          <div class="type-title" id="index1">全数量检测的引领者</div>

          <div class="type-content flex">
            <div class="type-content-left">
              <ul>
                <li v-for="item in typeList" :class="{'select':typeSelect==item.code}"
                    @click="bnt_selectType(item.code)">{{item.name}}
                </li>
              </ul>
            </div>
            <div class="type-content-right">
              <div class="pName">{{proObjList.name}}</div>
              <div class="pDetail">{{proObjList.digest}}
              </div>
              <div class="pBtn flex-center"  @click="toPape(proObjList)">查看案例</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>
<script type="text/javascript">
  import header1 from "@/components/header1"
  import footers from "@/components/footers"
  import page from "@/components/page"
  import vueSeamless from 'vue-seamless-scroll'
  import axios from 'axios'
  import wapIndex from "../case/wapIndex";
  import eventBus from "../../assets/js/eventBus";

  export default {
    name: "case",
    components: {header1, footers, vueSeamless,wapIndex},
    data() {
      return {
        projectList: [],
        typeSelect: "",
        typeList: [],
        selectIndex1: 1,
        pageIndex1: 0,
        proObjList:{
          name:"",
          orgName:"",
          cover:""
        },
        wapShow:false
      }
    },
    computed: {
      defaultOptionLeft() {
        return {
          step: 1, //步长 越大滚动速度越快
          limitMoveNum: 0, //启动无缝滚动最小数据量 this.dataList.length
          hoverStop: true, //是否启用鼠标hover控制
          direction: 1, //1 往上 0 往下
          openWatch: true, //开启data实时监听
          singleHeight: 432, //单条数据高度有值hoverStop关闭
          waitTime: 0, //单步停止等待时间。
          timeShow: false,
        }
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.$nextTick(() => {
            if(this.$route.query.index){
              if( document.querySelector("#index1" )){
                document.querySelector("#index1").scrollIntoView(true);
              }
            }

          })
          this.getProjectcList()
          this.getTypeList();
        }
      })


    },
    methods: {
      toPape(data) {
        this.$router.push({
          path: '/caseDetail',
          query: {
            id: data.id
          }
        })
      },
      bnt_selectType(val) {
        this.typeSelect = val
      this.getAProjectcList(val)
      },
      //获取案例项目
      getProjectcList() {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200`).then(res => {
          this.pageIndex1 = res.data.data.pages;
          this.projectList = res.data.data.list;

        })
      },
      getAProjectcList(code) {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200&typeCode=${code}`).then(res => {
          this.proObjList = res.data.data.list.length>0?res.data.data.list[0]:{
            name:"",
            orgName:""
          };
        })
      },
      //获取项目类型
      getTypeList(){
        axios.get(this.pageUrl + `/project-case-type/page?pageNo=1&pageSize=200`).then(res => {
          this.typeList = res.data.data.list;
          this.typeSelect = res.data.data.list[0].code
          if(this.$route.query.index){
            this.typeSelect=this.$route.query.index
            this.getAProjectcList(this.$route.query.index)
          }else {
            if(this.typeList[0]){
              this.getAProjectcList(this.typeList[0].code)
            }
          }
        })
      }
    }
  }
</script>
<style scoped>
  .case-box {
    margin-top: 80px;
  }

  .case-box .case-banner {
    width: 100%;
    height: 560px;
  }

  .case-banner .homme-sp1 {
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 6px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    color: #000000;
    transform: translateX(0px);
    position: absolute;
    top: 90px;
    left: 0;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;

  }

  .case-banner .homme-sp2 {
    position: absolute;
    top: 206px;
    left: 0;
    width: 614px;
    height: 98px;
    font-size: 24px;
    opacity: 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    letter-spacing: 4px;
    animation-timing-function: ease;
    animation-delay: 1s;
    animation-fill-mode: forwards;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgba(92, 93, 95, 1);
  }

  .case-box .case-banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 0;
  }

  .case-box .case-content {
    padding-top: 54px;
    background: #FFFFFF;
  }

  .case-box .case-content .t1 {
    font-size: 26px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
    padding-bottom: 40px;
  }

  .case-box .case-content-box {
    display: grid;
    grid-template-columns: repeat(3, 389px);
    grid-gap: 13px;
    margin-top: 20px;
    overflow: hidden;
  }

  .case-box .case-content-box .case-li {
    background-color: #F1F3F9;
    border-radius: 8px 8px 8px 8px;
    cursor: pointer;
    height: 340px;
    position: relative;
    overflow: hidden;

  }

  .case-box .case-content-box .case-li.select:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    /*最后一个参数是半透明度，可以透过调整0-1的数值，调整到满意的透明度*/
    background-color: rgba(0, 0, 0, 0.2);
  }

  .case-box .case-content-box .case-li img {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: all 0.5s ease-in-out;
    z-index: 1;
  }

  .case-box .case-content-box .case-li:hover img {
    transform: scale(1.2);
  }

  .case-box .case-content-box .case-li .year {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
  }

  .case-box .case-content-box .case-li .name {
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 16px;
  }

  .case-box .case-content-box .case-li .line {
    width: 84px;
    height: 4px;
    background: #0071EF;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin: 10px auto 0;
  }

  .case-box .case-content-box .case-li .detail {
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 18px;
  }

  .case-box .case-content-box .case-li .more {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #0071EF;
    text-align: center;
    margin: 67px auto 0;
    width: 110px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 88px 88px 88px 88px;
  }

  .type-box {
    height: 784px;
    background-color: #0D0D2B;
    border-radius: 0px 0px 0px 0px;
    width: 100%;
    margin-top: 40px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url("../../assets/imgs/case/2.png");
  }

  .type-box .type-title {
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    padding-top: 64px;
  }

  .type-box .type-content {
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .type-box .type-content .type-content-left {
    padding-top: 30px;
    width: 456px;
    height: 564px;
    box-sizing: border-box;
    background: rgba(25, 32, 59, 0.72);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #FFFFFF;
    overflow: hidden;
  }

  .type-box .type-content .type-content-left ul li {
    list-style: none;
    margin-left: 20px;
    width: 376px;
    height: 64px;
    border-radius: 8px 8px 8px 8px;
    line-height: 64px;
    cursor: pointer;
    font-size: 24px;
    padding-left: 66px;
    box-sizing: border-box;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    color: #FFFFFF;
    margin-bottom: 20px;
  }

  .type-box .type-content .type-content-left ul li.select {
    background: linear-gradient(132deg, #34E4AA 0%, #2C68FF 100%);
    font-weight: bold;
  }

  .type-box .type-content .type-content-right {
    width: 728px;
    height: 564px;
    background: rgba(25, 32, 59, 0.72);
    border-radius: 8px 8px 8px 8px;
    margin-left: 20px;
    padding: 47px 64px 42px;
    box-sizing: border-box;
    position: relative;
  }

  .type-box .type-content .type-content-right .pName {
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .type-box .type-content .type-content-right .pDetail {
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    color: #FFFFFF;
    margin-top: 40px;
    line-height: 2;
    letter-spacing: 1px;
    word-break: break-word;
  }

  .type-box .type-content .type-content-right .pBtn {
    width: 176px;
    height: 52px;
    opacity: 1;
    border: 1px solid #ddd;
    border-image: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%) 30 30;
    clip-path: inset(0 round 88px);
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    position: absolute;
    right: 64px;
    bottom: 42px;
  }
</style>



// WEBPACK FOOTER //
// src/view/case/index.vue